import axios from "axios";
import env from "../env";

const api_url = env.API_URL;

export const addMaterialFilePath = async (body:any, token: string) => {
    try {
        const response = await axios.post(`${api_url}materials/file-path`,body, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response;
    } catch (error) {
        throw error;
    }
}

export const deleteMaterialFilePath = async (id:any, token: string) => {
    try {
        const response = await axios.delete(`${api_url}materials/file-path?id=${id}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response;
    } catch (error) {
        throw error;
    }
}

export const deleteMaterial = async (id:any, token: string) => {
    try {
        const response = await axios.delete(`${api_url}materials?id=${id}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response;
    } catch (error) {
        throw error;
    }
}

export const addMaterial = async (body:any, token: string) => {
    try {
        const response = await axios.post(`${api_url}materials/`,body, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'multipart/form-data'
            }
        });
        return response;
    } catch (error) {
        throw error;
    }
}

export const getMaterialPaths = async (programme: string, stream: string, subject: string, token: string) => {
    try {
        const response = await axios.get(`${api_url}materials/file-path`, {
            headers: {
                Authorization: `Bearer ${token}`
            },
            params: {
                programme,
                stream,
                subject
            }
        });
        return response;
    } catch (error) {
        throw error;
    }
}

export const getMaterial = async (id:any,fileId:any,token:any) => {
    try {
        const response = await axios.get(`${api_url}materials?id=${id}&filePathId=${fileId}`, {
            headers: {
                Authorization: `Bearer ${token}`
            },
        });
        return response;
    } catch (error) {
        throw error;
    }
}


